var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offerFooter"},[_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.sendOffer}},[_vm._v("发送Offer")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }